import { render, staticRenderFns } from "./performance_register.vue?vue&type=template&id=6202b43c&"
import script from "./performance_register.vue?vue&type=script&lang=js&"
export * from "./performance_register.vue?vue&type=script&lang=js&"
import style0 from "./performance_register.vue?vue&type=style&index=0&id=6202b43c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports